import React, { useState } from 'react'
import { usePersonalStore } from '../../../stores/personalInfo'
import { useInitializeStore } from '../../../stores/initialize'
import { useFormsStore } from '../../../stores/onboarding'
import Toast from 'react-native-toast-message'
import { globalStyles } from '../../../static/styles/global'
import { ActivityIndicator, ScrollView, View } from 'react-native'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import Card from '../../shared/card/Card'
import moment from 'moment'
import Canvas from '../../canvas'
import CustomButton from '../../shared/button/Button'
import SignatureFormView from '../SignatureFormView'

const InInformationOnline = ({ navigation, route }) => {
    const {
        userId,
        mode,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey,
        values,
        checkedids
    } = route.params

    const personalstore = usePersonalStore()
    const intializeStore = useInitializeStore()
    const { loading, postinonline } = useFormsStore()




    const handlesubmit = async (signatureDataURL: any) => {
        const data = {
            entityId: personalstore?.personalData?.entityId,
            essUserKey:
                intializeStore?.initializeData?.userkey,
            essObKey: essUserOnBoardingKey,
            essUserOnBoardingFormKey:
                essUserOnBoardingFormKey,
            completeOnline: true,
            indianaCountyOfResidence: values?.indianacountrycode,
            principalEmployment: values?.principalemploymentcode,
            changesEffective: values?.changeseffective ? true : false,
            residentOfIndiana: Number(values?.residentofIndiana),
            claimExemption: Number(values?.spousenotclaimingexemption),
            dependentExemption: Number(values?.dependent),
            additionalExemptions: checkedids,
            noofBoxesChecked: checkedids?.length,
            total: Number(values?.residentofIndiana) + Number(values?.spousenotclaimingexemption) + Number(values?.dependent) + checkedids?.length,
            eachQualifyingDependent: Number(values?.eachqualifyingdependent),
            firstTimeClaiming: Number(values?.firsttimeclaiming),
            adoptedClaiming: Number(values?.adoptedclaiming),
            additionalStateWithholding: Number(values?.additionalstatewithholding),
            additionalCountyWithholding: Number(values?.additionalcountywithholding),
            IndianaCountyOfResidenceText: values?.indiana_country_of_residence,
            PrincipalEmploymentText: values?.pricipal_employment,
            sign: signatureDataURL,
        }
        const response = await postinonline(data)
        if (response?.success) {
            await Toast.show({
                type: 'success',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60,
                onHide: () => {
                    navigation.replace('OnboardingForms')
                }
            })
        } else {
            await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
            })
        }
    }
    return (
        <>
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'IN Withholding Taxation'}
                    />
                </View>
            </View>

            <SignatureFormView
                essUserOnBoardingFormKey={essUserOnBoardingFormKey}
                essUserOnBoardingKey={essUserOnBoardingKey}
                isSubmitting={loading}
                onPrevious={() =>
                    navigation.navigate('InInformationForm', {
                        essUserOnBoardingFormKey,
                        essUserOnBoardingKey,
                        values,
                        mode: "online",
                    })
                }
                onSubmit={handlesubmit}
            />

        </>
    )
}


export default InInformationOnline
